// Copyright 2018-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import AppUpgrade from "./AppUpgrade";

export default AppUpgrade;
